export default {
  getThreeMonthBannerData(state) {
    return state.threeMonthValues;
  },
  getCphData(state) {
    return state.cphData;
  },
  getCphChartKey(state) {
    return state.cphChartKey;
  },
  getLthData(state) {
    return state.lthData;
  },
  getCplData(state) {
    return state.cplData;
  },
  getCplChartKey(state) {
    return state.cplChartKey;
  },
  getLthChartKey(state) {
    return state.lthChartKey;
  },
};
